module.exports = __webpack_public_path__ + "static/videos/woodcut_print004.cc3167d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/woodcut/woodcut_print004.mp4
// module id = 479
// module chunks = 1